import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useFormContext } from 'react-hook-form';
import { PickerFormControl, } from '../Picker/PickerFormControl';
export function FormMemberPicker({ name, validation, ...rest }) {
    const { control } = useFormContext();
    return (_jsx(Controller, { control: control, name: name, rules: validation, render: ({ field: { onChange, value }, fieldState: { error } }) => (_jsx(PickerFormControl.MemberPicker, { name: name, invalid: !!(error === null || error === void 0 ? void 0 : error.message), error: error === null || error === void 0 ? void 0 : error.message, value: value, onChange: value => {
                onChange(value);
            }, ...rest }, void 0)) }, void 0));
}
//# sourceMappingURL=FormMemberPicker.js.map